import { render, staticRenderFns } from "./CertificateLogsDialog.vue?vue&type=template&id=170245a4&"
import script from "./CertificateLogsDialog.vue?vue&type=script&lang=ts&"
export * from "./CertificateLogsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports